import { t } from '@framework/i18n/intl/i18next.ts';

/**
 * Errore mostrato quando le intersezioni di un layer superano `maxResults`: le
 * eccedenti non vengono visualizzate. La key è fissa così antd aggiorna il
 * toast esistente invece di accumularne uno nuovo a ogni ricalcolo o per più
 * layer. La traduzione è risolta al momento del toast, così segue lo switch
 * lingua a runtime.
 */
export function getIntersectionTruncatedError(params: {
  found: number;
  max: number;
}) {
  return {
    key: 'map-intersection-truncated',
    content: t(
      'map-widget.intersections-truncated-error',
      "Sono state trovate {{found}} intersezioni ma ne possono essere mostrate al massimo {{max}}. Le eccedenti non verranno visualizzate: riduci l'area disegnata.",
      { found: params.found, max: params.max },
    ),
  };
}
